import tableOperation from '../common/table-operation'

const getPaginatedNumberPools = function (state) {
  const { limit, currentPage, searchText = '' } = state.table

  const result = tableOperation.getPaginatedCollection({
    collection: [...state.numberPools],
    paginationConfig: {
      limit: limit,
      page: currentPage,
      query: searchText,
    },
  })

  return result
}

export default getPaginatedNumberPools
